"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TaxDocumentsCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const Files_1 = require("../shared/Files");
const Taxes_1 = __importDefault(require("../api/Taxes"));
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Loading_1 = __importDefault(require("../components/Loading"));
const Button_1 = __importDefault(require("../components/Button"));
const LoadingButton_1 = __importDefault(require("../components/LoadingButton"));
const react_i18next_1 = require("react-i18next");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        row: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center',
            marginLeft: size != 'sm' ? 12 : 0,
            marginRight: size != 'sm' ? 6 : 0
        },
        text: {
            color: THEME.Text,
            fontSize: size != 'sm' ? 18 : 16,
            textAlign: 'center'
        },
        rowButtonIcon: {
            color: THEME.Primary,
            marginRight: 6,
            marginBottom: -1
        },
        rowButtonText: {
            color: THEME.Primary,
            fontSize: (size != 'sm' ? 16 : 14),
            fontWeight: (size != 'sm' ? '400' : '500')
        },
        modal: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            height: Helper_1.Helper.isPlatformWeb ? react_native_1.Dimensions.get('window').height * 0.75 : react_native_1.Dimensions.get('window').height - 118,
            margin: Helper_1.Helper.isPlatformWeb ? -12 : 0
        },
        modalHeader: {
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: size != 'sm' ? 8 : 4,
            marginTop: size != 'sm' ? 8 : 0,
            marginHorizontal: Helper_1.Helper.isPlatformWeb ? 0 : -12,
        },
        modalHeaderText: {
            color: THEME.Primary,
            fontWeight: '500',
            fontSize: size != 'sm' ? 18 : 16,
            marginLeft: Helper_1.Helper.isPlatformWeb ? 12 : 2
        },
        modalScroll: {
            flex: 1,
            marginHorizontal: Helper_1.Helper.isPlatformWeb ? 0 : -24,
            marginBottom: Helper_1.Helper.isPlatformWeb ? 0 : -24,
            paddingHorizontal: 12,
            minWidth: size != 'sm' ? 480 : 0
        },
        yearHeader: {
            backgroundColor: THEME.SmokeWhite,
            paddingVertical: 4,
            paddingHorizontal: 8,
            borderRadius: 4
        },
        yearHeaderText: {
            color: THEME.SmokeWhiteText,
            fontWeight: '500',
            fontSize: (size != 'sm' ? 16 : 14)
        }
    });
};
const getTaxDocumentLabel = (form) => {
    switch (form) {
        case "W2":
            return "W-2";
        case "W2C":
            return "W-2C";
        case "1095C":
            return "1095-C";
        default:
            return form;
    }
};
const TaxDocumentRow = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const styles = useStyles();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef({});
    react_1.default.useEffect(() => {
        return () => {
            let promises = Object.values(promise.current);
            promises.forEach(p => p.cancel());
        };
    }, []);
    const getFileUrl = react_1.default.useCallback((type, year, action) => {
        promise.current[action]?.cancel();
        promise.current[action] = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => {
            switch (type) {
                case 'W2': return Taxes_1.default.getW2Download(token, year);
                case 'W2C': return Taxes_1.default.getW2CDownload(token, year);
                case '1095C': return Taxes_1.default.get1095cDownload(token, year);
            }
        }).then((data) => {
            if (__DEV__) {
                return new Promise(resolve => setTimeout(() => resolve(data), 2000));
            }
            else {
                return data;
            }
        })).then((data) => data.url);
        return promise.current[action];
    }, []);
    const getDownload = (type, year) => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': `Download ${type}`,
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        return getFileUrl(type, year, 'save').then((url) => {
            let name = 'Nextep_' + year + '_' + type + '.pdf';
            return Files_1.Files.SaveToDownloads(name, 'application/pdf', url);
        });
    };
    const loadViewFile = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': `View ${props.form}`,
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        return getFileUrl(props.form, props.year, 'view');
    };
    const viewFile = (type, year, url) => {
        props.navigation.navigate('PdfScreen', { uri: url, title: year + ' ' + getTaxDocumentLabel(type) });
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.row, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 12, flexDirection: 'row', alignItems: 'center', marginLeft: size != 'sm' ? 0 : 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.FileLines, size: size != 'sm' ? 18 : 16, style: [styles.rowButtonIcon] }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.text, { fontWeight: '400', marginTop: 2 }], children: props.year }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.text, { marginLeft: 6, marginTop: 2 }], children: getTaxDocumentLabel(props.form) }), (props.form === 'W2C') &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 6, paddingVertical: 2, backgroundColor: "#3fad98", borderRadius: 2, marginLeft: 6 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: 10, fontWeight: '500', textAlign: 'center', color: THEME.AlwaysWhite }, children: t('myPay:text.correction') }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 6 }, children: (0, jsx_runtime_1.jsxs)(LoadingButton_1.default, { "aria-label": Helper_1.Helper.isPlatformWeb ? t('common:buttons.download') : t('common:buttons.save'), type: "borderless", onLoad: () => getDownload(props.form, props.year), onDone: () => props.onDownload(true), onError: () => props.onDownload(false), children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.ArrowDownToLine, size: size != 'sm' ? 18 : 16, style: [styles.rowButtonIcon] }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.rowButtonText, children: Helper_1.Helper.isPlatformWeb ? t('common:buttons.download') : t('common:buttons.save') })] }) }), !Helper_1.Helper.isPlatformWeb &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 6 }, children: (0, jsx_runtime_1.jsxs)(LoadingButton_1.default, { "aria-label": t('common:buttons.view'), type: "borderless", onLoad: () => loadViewFile(), onDone: (url) => viewFile(props.form, props.year, url), onError: () => props.onDownload(false), children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.BookOpen, size: size != 'sm' ? 18 : 16, style: [styles.rowButtonIcon] }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.rowButtonText, children: t('common:buttons.view') })] }) })] }));
};
const TaxDocuments = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const styles = useStyles();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const [viewAll, setViewAll] = react_1.default.useState(false);
    let y = [...props.data.yearsW2, ...props.data.yearsW2C, ...props.data.years1095C];
    let unique = (v, i, self) => self.indexOf(v) === i;
    const years = y.filter(unique);
    const yearsToDisplay = viewAll ? years : years.slice(0, 2);
    const showViewAll = years.length != years.slice(0, 2).length;
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 6, marginBottom: 0 }, children: [yearsToDisplay.map((year) => (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.yearHeader, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.yearHeaderText, children: year }) }), props.data.yearsW2.includes(year) &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 4 }, children: (0, jsx_runtime_1.jsx)(TaxDocumentRow, { year: year, form: "W2", onDownload: (s) => react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: s ? "success" : "error", message: s ? t('myPay:messages.downloaded') : t('myPay:messages.downFail') }), navigation: props.navigation }) }), props.data.yearsW2C.includes(year) &&
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 4 }, children: (0, jsx_runtime_1.jsx)(TaxDocumentRow, { year: year, form: "W2C", onDownload: (s) => react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: s ? "success" : "error", message: s ? t('myPay:messages.downloaded') : t('myPay:messages.downFail') }), navigation: props.navigation }) })] }), props.data.yearsW2.includes(year) &&
                        props.data.years1095C.includes(year) &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator] }), props.data.years1095C.includes(year) &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 4 }, children: (0, jsx_runtime_1.jsx)(TaxDocumentRow, { year: year, form: "1095C", onDownload: (s) => react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: s ? "success" : "error", message: s ? t('myPay:messages.downloaded') : t('myPay:messages.downFail') }), navigation: props.navigation }) })] }, year)), showViewAll &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: props.data == null, onPress: () => setViewAll(!viewAll), text: viewAll ? t('common:text.viewRecent') : t('common:text.viewAll'), textSize: 14, type: "borderless" }) })] })] }));
};
function TaxDocumentsCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [data, setData] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Taxes_1.default.getDocuments(token))).then(r => {
            if ((r == null) ||
                (r?.yearsW2?.length == 0 && r?.yearsW2C?.length == 0 && r?.years1095C?.length == 0)) {
                setData(null);
                setStatus('empty');
            }
            else {
                setData(r);
                setStatus('done');
            }
        }).catch(() => {
            setData(null);
            setStatus('error');
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('myPay:text.docs'), style: { marginBottom: 8 } }), (status == 'done') &&
                (0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsx)(TaxDocuments, { data: data, navigation: props.navigation }) }), (status == 'empty') &&
                (0, jsx_runtime_1.jsx)(FadeInView_1.default, { style: { marginTop: 4 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: "center", justifyContent: "center", marginVertical: 4 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.FileCircleQuestion, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { textAlign: 'center', fontSize: (size != 'sm' ? 16 : 14), color: THEME.TextNull }, children: t('myPay:text.noDocs') })] }) }), (status == 'loading' || status == 'error') &&
                (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() })] }));
}
;
